export default "__VITE_ASSET__DpcvYFz6__"